import {css} from "@panda/css";

export const prettyScroll = css.raw({
    paddingRight: "1px",
    overflowY: "auto",

    "&::-webkit-scrollbar-track": {
        WebkitBoxShadow: "inset 0 0 4px 0 rgba(0, 0, 0, 0.3)",
        backgroundColor: "#fff"
    },

    "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px"
    },

    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#ccc",
        transition: "background-color 0.2s ease-in-out"
    },

    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#ccc"
    }
});
import {css} from "@panda/css";

export const prettyScroll = css.raw({
    paddingRight: "1px",
    overflowY: "auto",

    "&::-webkit-scrollbar-track": {
        WebkitBoxShadow: "inset 0 0 4px 0 rgba(0, 0, 0, 0.3)",
        backgroundColor: "#fff"
    },

    "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px"
    },

    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#ccc",
        transition: "background-color 0.2s ease-in-out"
    },

    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#ccc"
    }
});
